import { render, staticRenderFns } from "./certChannel.vue?vue&type=template&id=0d2e50e6&scoped=true&"
import script from "./certChannel.vue?vue&type=script&lang=js&"
export * from "./certChannel.vue?vue&type=script&lang=js&"
import style0 from "./certChannel.vue?vue&type=style&index=0&id=0d2e50e6&lang=scss&scoped=true&"
import style1 from "./certChannel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2e50e6",
  null
  
)

export default component.exports